import { ContractManagementMenuItems } from '@forvalter/routing/Routes';
import { AppMenuItems } from '@klp/core/app/config';
import {
    ProjectMenuItems,
    ProjectSchemaMenuItems,
} from '@klp/projectdxbo/config';
import { ReportMenuItems } from '@klp/report/config';
import { EnvironmentMenuItems } from '@klp/environment/config';
import { ForvaltningsplanMenuItems } from '@klp/forvaltningsplan/config';
import { AreaKeyFiguresMenuItems } from '@klp/areakeyfigures';
import { EconomyKeyFiguresMenuItems } from '@klp/economykeyfigures';
import { ReportMappingMenuItems } from '@klp/reportMapping/config';
import { LeverandorMenuItems } from '@klp/leverandor';

export const menuItems = [
    ...AppMenuItems,
    ...ContractManagementMenuItems,
    ...ForvaltningsplanMenuItems,
    ...ReportMenuItems,
];

export const environmentMenuItems = [
    ...EnvironmentMenuItems,
    ...ReportMappingMenuItems,
];

export const keyFiguresMenuItems = [
    ...AreaKeyFiguresMenuItems,
    ...EconomyKeyFiguresMenuItems,
];

export const projectMenuItems = [
    ...ProjectMenuItems,
    ...ProjectSchemaMenuItems,
];

export const leverandorMenuItems = [...LeverandorMenuItems];
